export default [
  {
    path: 'calls',
    name: 'calls-specialist',
    component: () => import('@/components/videoCall/agoraVideoCall.vue'),
    meta: {
      layout: 'full',
      resource: 'specialist',
      action: 'manage',
    },

  },
]
